export const enTranslations = {
  menu: {
    theme: {
      light: "Light",
      dark: "Dark",
    },
  },
};
